import React from 'react';
import 'tailwindcss/tailwind.css';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Landing from './components/pages/LandingPage';
import LoginPage from './components/pages/LoginPage';
import RegisterPage from "./components/pages/RegisterPage";
import Home from './components/pages/GaleriaStandup';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsAndConditions from './components/pages/TermsAndConditions';
import ReproductorVideoShows from './components/pages/Reproductor/VideoShows';
import UserProfile from './components/pages/PerfilUsuario';
import CommentSection from './components/pages/Comentarios';
import { jwtDecode } from "jwt-decode";
import VentaEntradas from './components/pages/VentaEntradas';
import ShowsEnVivo from './components/pages/ShowsEnVivo';
import ForgotPasswordPage from './components/pages/LoginPage/ForgotPassword';
import EmailVerificadorPage from './components/pages/RegisterPage/EmailVerificador';
import RegistroExitosoPage from './components/pages/RegisterPage/RegistroExitoso';
import UnderConstructionPage from './components/pages/UnderConstructionPage';
import ComediantePerfilPage from './components/pages/ComediantePerfilPage';
import ComediantesListPage from './components/pages/ComediantesListPage';

// Nuevos componentes para Livestreaming
import LivestreamViewer from './components/pages/Reproductor/ReproductorLiveStream';
import LivestreamAdmin from './components/pages/LivestreamAdmin';
import PreguntasFrecuentes from './components/pages/PreguntasFrecuentes';
import ContactPage from './components/pages/ContactPage';
import SupportPage from './components/pages/SupportPage';
import CreateTicketPage from './components/pages/SupportPage/CreateTicketPage';
import PDFViewerPage from './components/pages/KeyNotePage';
import SubscriptionPlansPage from './components/suscripcion/SuscriptionPlansPage';
import SubscriptionSuccessPage from './components/suscripcion/SuscriptionSuccessPage';
import SubscriptionManagePage from './components/suscripcion/SubscriptionManagePage';
import CompraExitosa from './components/pages/VentaEntradas/CompraExitosa';

// Función auxiliar para verificar autenticación que podemos reutilizar
const isAuthenticated = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    return !(decodedToken.exp && decodedToken.exp < currentTime);
  } catch (error) {
    console.error("Error verificando token:", error.message);
    return false;
  }
};

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

// Nuevo componente para rutas públicas que redirige a usuarios autenticados
const PublicRoute = ({ children }) => {
  return !isAuthenticated() ? children : <Navigate to="/home" />;
};

// Componente para rutas protegidas específicas para administradores
const AdminRoute = ({ children }) => {
  const isAdmin = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;
      
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Verificar si el token es válido y el usuario es administrador
      if (decodedToken.exp && decodedToken.exp < currentTime) return false;
      
      // Asumiendo que el rol está en decodedToken.role o similar
      return decodedToken.rol === "Administrador" || decodedToken.isAdmin === true;
    } catch (error) {
      console.error("Error verificando permisos de administrador:", error.message);
      return false;
    }
  };

  return isAdmin() ? children : <Navigate to="/home" />;
};

const App = () => {
  // Verificar autenticación al inicio
  React.useEffect(() => {
    const validateSession = () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
        }
      } catch (error) {
        console.error("Error en validación de sesión:", error.message);
        localStorage.removeItem("token");
      }
    };

    validateSession();
  }, []);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <div className="flex-grow mb-16">
          <Routes>
            {/* Rutas públicas que redirigen a usuarios autenticados */}
            <Route path="/" element={
              <PublicRoute>
                <Landing />
              </PublicRoute>
            } />
            <Route path="/login" element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } />
            {
            <Route path="/register" element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            } />}
            <Route path="/forgotPassword/" element={
              <PublicRoute>
                <ForgotPasswordPage />
              </PublicRoute>
            } />
            <Route path="/verificar-email" element={
              <PublicRoute>
                <EmailVerificadorPage />
              </PublicRoute>
            } />
            <Route path="/registro-exitoso" element={
              <PublicRoute>
                <RegistroExitosoPage />
              </PublicRoute>
            } />
            
            
            {/* Rutas públicas que todos pueden ver */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/keynote" element={<PDFViewerPage />} />
            <Route path="/nosotros" element={<UnderConstructionPage />} />
            <Route path="/nosotros/comediantes" element={<UnderConstructionPage />} />
            <Route path="/nosotros/showenvivo" element={<UnderConstructionPage />} />
            
            {/* Rutas protegidas que requieren autenticación */}
            <Route path="/home" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/contenido/ver/:idCapitulo" element={
              <ProtectedRoute>
                <ReproductorVideoShows />
              </ProtectedRoute>
            } />
            <Route path="/Identity/Account/Manage" element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } />
            <Route path="/comentarios" element={
              <ProtectedRoute>
                <UnderConstructionPage />
              </ProtectedRoute>
            } />
            <Route path="/Ventas/Entradas" element={
              <ProtectedRoute>
                <VentaEntradas />
              </ProtectedRoute>
            } />

            <Route path="/compra-exitosa" element={<ProtectedRoute><CompraExitosa /></ProtectedRoute>} />

            <Route path="/contenido/EnVivo" element={
              <ProtectedRoute>
                <ShowsEnVivo />
              </ProtectedRoute>
            } />

            <Route path="/comediante/:idComediante" element={
              <ProtectedRoute>
                <ComediantePerfilPage />
              </ProtectedRoute>
            } />

            <Route path="/comediantes" element={
              <ProtectedRoute>
                <ComediantesListPage />
              </ProtectedRoute>
            } />

            {/* Nuevas rutas para livestream */}
            <Route path="/livestream/:idLivestream" element={
              <ProtectedRoute>
                <LivestreamViewer />
              </ProtectedRoute>
            } />

            {/* Rutas protegidas de soporte */}
            <Route path="/soporte" element={
              <ProtectedRoute>
                {/*}
                <SupportPage />
                */}
                <UnderConstructionPage />
              </ProtectedRoute>
            } />

            <Route path="/nuevo-ticket" element={ 
              <ProtectedRoute>
                {/*}
                <CreateTicketPage />
                */}
                <UnderConstructionPage />
              </ProtectedRoute>
            } />

            {/* Rutas protegidas para el perfil de usuario */}

            {/* Rutas protegidas para administradores */}
            <Route path="/admin/livestreams" element={
              <AdminRoute>
                <LivestreamAdmin />
              </AdminRoute>
            } />
            <Route path="/admin/livestreams/new" element={
              <AdminRoute>
                <UnderConstructionPage />
              </AdminRoute>
            } />
            <Route path="/admin/livestreams/edit/:id" element={
              <AdminRoute>
                <UnderConstructionPage />
              </AdminRoute>
            } />
            
            {/* Rutas de suscripciones protegidas */}
<Route path="/planes" element={
  <ProtectedRoute>
    {/*<SubscriptionPlansPage />*/}
    <SubscriptionPlansPage />
  </ProtectedRoute>
} />

<Route path="/mi-suscripcion" element={
  <ProtectedRoute>
    {/*<SubscriptionManagePage />*/}
    <SubscriptionManagePage />
  </ProtectedRoute>
} />

<Route path="/suscripcion-exitosa" element={
  <ProtectedRoute>
    {/*<SubscriptionSuccessPage />*/}
    <UnderConstructionPage />
  </ProtectedRoute>
} />



            {/* Ruta de error 404 - Redirige a la página principal */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;